import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResourceFileService {
  constructor(
    private http: HttpClient
  ) { }

  getResourceFile(){
    return this.http.get(`${environment.apiEndpoint}api/ResourceFile`)
  }
  postResourceFile(data){
    return this.http.post(`${environment.apiEndpoint}api/ResourceFile`, data)
  }
  deleteResourceFile(id){
    return this.http.delete(`${environment.apiEndpoint}api/ResourceFile/${id}`)

  }
}
